import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './main.css';
import { addResourceHints } from './utils/performance';

// Lazy load Sentry to reduce initial bundle size
const initializeSentry = async () => {
  // Load Sentry in all environments for comprehensive error tracking
  await import('./utils/sentry');
};

// Lazy load Core Web Vitals monitoring
const initializeCoreWebVitals = async () => {
  try {
    // Only initialize in browser environment
    if (typeof window !== 'undefined') {
      const { default: coreWebVitalsMonitor } = await import('./services/CoreWebVitalsMonitor');
      
      // Initialize monitoring after a short delay to avoid blocking startup
      setTimeout(async () => {
        await coreWebVitalsMonitor.initialize();
        
        if (import.meta.env.MODE === 'development') {
          console.log('🎯 Core Web Vitals monitoring initialized');
        }
      }, 2000); // 2 second delay to ensure app is fully loaded
    }
  } catch (error) {
    console.warn('⚠️ Failed to initialize Core Web Vitals monitoring:', error);
  }
};

// Lazy load development tools
const initializeDevelopmentTools = async () => {
  if (import.meta.env.MODE !== 'production') {
    const axe = await import('@axe-core/react');
    axe.default(React, ReactDOM, 1000);
  }
};

// Add resource hints for better performance
addResourceHints();

// Initialize Sentry asynchronously
initializeSentry().catch(console.error);

// Initialize Core Web Vitals monitoring asynchronously
initializeCoreWebVitals().catch(console.error);

// Initialize development tools asynchronously
initializeDevelopmentTools().catch(console.error);

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
